<router-outlet></router-outlet>

<button class="btn bg-blue-500 text-white px-4 py-2 hover:bg-blue-700">tailwindcss</button>

<div class="mt-4 ml-20">
    <button class="btn bg-blue-500 text-white px-4 py-2 hover:bg-blue-700 rounded mt-2" (click)="hello()">圆角</button>
</div>